import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Card, Checkbox, message, Modal, Popover } from 'antd'
import { useSelector } from 'react-redux'
import {
  changeWriteOffNFCBatchNumberStatus,
  downloadBatchInfo,
  findBatchNoModules,
  findPlantModules,
  getWriteOffNFCBatchNumberDetailList,
  getWriteOffNFCBatchNumberList,
  uploadWriteOffNFCBatchNo
} from '@/services/writeOff/writeOff'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import {
  downLoadFileBlob,
  formatMessage,
  formatMessageNew,
  formatSpcEndTime,
  formatSpcStartTime,
  paginationInit
} from '@/utils/common'
import { InfoCircleOutlined } from '@ant-design/icons'
import CustomUploadBtn from '../../components/Upload/CustomUpload'
import dayjs from 'dayjs'
import { modalError } from '../../utils/modalUtils'
import { disableWriteOffNFCBatchNumberStatus } from '../../services/writeOff/writeOff'
import { hasPermission } from '../../annotations/nike-react'

const dateFormat = 'YYYY-MM-DD HH:mm'
const menu_nfc_configuration_writeOffUIDDisablementReport_view_button_disable =
  'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_disable'
const menu_nfc_configuration_writeOffUIDDisablementReport_view_button_scanComplete =
  'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_scanComplete'
const menu_nfc_configuration_writeOffUIDDisablementReport_view_button_backToScanning =
  'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_backToScanning'
const menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload_submit =
  'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload&submit'
const batchStatusOptions = [
  { label: 'Open', value: 'Open' },
  { label: 'Scanning', value: 'Scanning' },
  { label: 'Scan Complete', value: 'Scan Complete' },
  { label: 'Submitted', value: 'Submitted' },
  { label: 'Disabling', value: 'Disabling' },
  { label: 'Closed', value: 'Closed' },
  { label: 'Fail', value: 'Fail' }
]
const UIDDisablementReport = props => {
  let commonStore = useSelector(state => state.commonStore)
  let languageState = useSelector(state => state.commonStore.language)
  const uploadBtnRef = useRef()
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [detailTableList, setDetailTableList] = useState([])
  const [functionPlantOptions] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [batchNo, setBatchNo] = useState('')
  const [batchStatus, setBatchStatus] = useState('')
  const [batchId, setBatchId] = useState('')
  const [plant, setPlant] = useState('')
  const [scanQty, setScanQty] = useState('')
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.writeOff.batchNumber',
      key: 'batchNoList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.writeOff.batchStatus',
      key: 'batchStatusList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: batchStatusOptions,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.writeOff.plant',
      key: 'plantList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRangeSpc',
      label: 'languageObj.writeOff.disableDate',
      key: 'disableDate',
      format: dateFormat,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRangeSpc',
      label: 'languageObj.writeOff.scanDate',
      key: 'scanDate',
      format: dateFormat,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRangeSpc',
      label: 'languageObj.writeOff.disablementSubmitDate',
      key: 'disablementSubmitDate',
      format: dateFormat,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    }
  ]
  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.batchNumber'),
      dataIndex: 'batchNo',
      width: 110,
      fixed: 'left',
      render: (text, record) => {
        return (
          <div
            className="link_name"
            onClick={() => {
              addAndEdit(record)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.batchStatus'),
      dataIndex: 'batchStatus',
      width: 110,
      fixed: 'left',
      render: text => {
        const color = text === 'Scan Complete' ? '#52c41a' : undefined
        return (
          <div className="word_break_all" style={{ color }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.plant'),
      dataIndex: 'plant',
      width: 80,
      fixed: 'left',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.planedQty'),
      dataIndex: 'plannedQty',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.scannedQty'),
      dataIndex: 'scannedQty',
      width: 100,
      render: text => {
        return (
          <div className="word_break_all" style={{ minWidth: 120, color: '#fa8c16' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.noNfcTagQty'),
      dataIndex: 'noNfcTagQty',
      width: 140,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.scanNoResponseTagQty'),
      dataIndex: 'scanNoResponseTagQty',
      width: 180,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.readableUidQty'),
      dataIndex: 'readableUidQty',
      width: 130,
      render: text => {
        return (
          <div className="word_break_all" style={{ minWidth: 120, color: '#fa8c16' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.readableActiveUidQty'),
      dataIndex: 'readableActiveUidQty',
      width: 170,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.readableDisabledUidQty'),
      dataIndex: 'readableDisabledUidQty',
      width: 190,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.actualSubmitQty'),
      dataIndex: 'actualSubmitQty',
      width: 140,
      render: text => {
        return (
          <div className="word_break_all" style={{ minWidth: 120, color: '#fa8c16' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.notTaggedUidQty'),
      dataIndex: 'notTaggedQty',
      width: 140,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const disabaleUidDetailColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.nfcUid'),
      dataIndex: 'uid',
      align: 'center',
      width: 210,
      fixed: 'left',
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.taggedSku'),
      dataIndex: 'taggedSku',
      align: 'center',
      width: 140,
      fixed: 'left',
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.division'),
      dataIndex: 'division',
      align: 'center',
      width: 100,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.uidTaggingStatus'),
      dataIndex: 'uidTaggingStatus',
      align: 'center',
      width: 200,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.uidStatusBefore'),
      dataIndex: 'uidBeforeStatus',
      align: 'center',
      width: 200,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.uidStatusAfter'),
      dataIndex: 'uidAfterStatus',
      align: 'center',
      width: 200,
      render: (text, record) => {
        return (
          <div
            className="word_break_all"
            style={{ textAlign: 'center', color: record.uidAfterStatus === 'Failed' ? '#ff4d4f' : undefined }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.excption'),
      dataIndex: 'exception',
      align: 'center',
      width: 230,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.scanDate'),
      dataIndex: 'scanTime',
      align: 'center',
      width: 230,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.sannerId'),
      dataIndex: 'scannerId',
      align: 'center',
      width: 140,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.disablementSubmitDate'),
      dataIndex: 'disablementSubmitTime',
      align: 'center',
      width: 280,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.disablementSubmitter'),
      dataIndex: 'disablementSubmitter',
      align: 'center',
      width: 260,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.disableDate'),
      dataIndex: 'disableTime',
      align: 'center',
      width: 180,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.writeOff.disableOperator'),
      dataIndex: 'disableOperator',
      align: 'center',
      width: 220,
      render: text => {
        return (
          <div className="word_break_all" style={{ textAlign: 'center' }}>
            {text}
          </div>
        )
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [detailPagination, setDetailPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [autoRefresh, setAutoRefresh] = useState(false)

  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    getDictionnaryDropListFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDictionnaryDropListFun = () => {
    let param = {
      isConfig: false
    }
    Promise.all([findPlantModules(param), findBatchNoModules()]).then(res => {
      try {
        searchListInit.forEach(searchItem => {
          if (['plantList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'plantList':
                const plantCodeList = res[0].resultData
                const plantOptions = plantCodeList.map(item => ({ value: item, label: item }))
                options = [...plantOptions]
                break
              default:
                break
            }
            searchItem.selectList = options
          }
          if (['batchNoList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'batchNoList':
                const batchNoList = res[1].resultData
                const batchNoOptions = batchNoList.map(item => ({ value: item, label: item }))
                options = [...batchNoOptions]
                break
              default:
                break
            }
            searchItem.selectList = options
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {}
    })
  }

  useEffect(() => {
    setSearchList(prev =>
      prev.map(item => (item.key === 'plantList' ? { ...item, selectList: functionPlantOptions } : item))
    )
  }, [functionPlantOptions])

  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const searchClearDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    setTableList([])
    // setTableListTotal([])
    setSelectedRowKeys([])
    // setQueryFlag(!queryFlag)
  }

  const addAndEdit = (record, detailPage = detailPagination) => {
    setVisibleFlag(true)
    setBatchId(record.id)
    const params = {
      batchId: record.id,
      size: detailPage.pageSize,
      pageNo: detailPage.currentPage
    }
    getWriteOffNFCBatchNumberDetailList(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setDetailTableList(records)
      const pg = {
        ...detailPage,
        total: dt.total
      }
      setBatchNo(record.batchNo)
      setPlant(record.plant)
      setScanQty(record.scannedQty)
      setBatchStatus(record.batchStatus)
      setDetailPagination(pg)
    })
  }

  const handleDetailCancel = () => {
    setVisibleFlag(false)
    setDetailTableList([])
    setBatchNo('')
    setPlant('')
    setScanQty('')
    setBatchStatus('')
    const pg = {
      ...detailPagination,
      currentPage: 1
    }
    setDetailPagination(pg)
    setDetailTableList([])
  }

  const searchDataFun = useCallback(() => {
    setSelectedRowKeys([])
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      batchNoList: info.batchNoList && info.batchNoList.length > 0 ? info.batchNoList : null,
      batchStatusList: info.batchStatusList && info.batchStatusList.length > 0 ? info.batchStatusList : null,
      plantList: info.plantList && info.plantList.length > 0 ? info.plantList : null,
      disableDateStart: formatSpcStartTime(info.disableDate),
      disableDateEnd: formatSpcEndTime(info.disableDate),
      scanDateStart: formatSpcStartTime(info.scanDate),
      scanDateEnd: formatSpcEndTime(info.scanDate),
      disablementSubmitDateStart: formatSpcStartTime(info.disablementSubmitDate),
      disablementSubmitDateEnd: formatSpcEndTime(info.disablementSubmitDate)
    }
    delete params.disableDate
    delete params.scanDate
    delete params.disablementSubmitDate

    getWriteOffNFCBatchNumberList({
      ...params,
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }, [pagination])

  useEffect(() => {
    let timer = null
    if (autoRefresh) {
      timer = setInterval(() => {
        searchDataFun()
        setSelectedRowKeys([])
      }, 5 * 60 * 1000) // 5分钟
    }
    return () => {
      if (timer) clearInterval(timer)
    }
  }, [autoRefresh, searchDataFun])

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const handleDetailTableChange = pagina => {
    const params = {
      ...detailPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setDetailPagination({ ...params })
    // 重新请求明细数据
    addAndEdit(
      {
        id: batchId, // 这里 batchId 需为当前批次的 id
        batchNo,
        plant,
        scannedQty: scanQty,
        batchStatus
      },
      params
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const downLoadFun = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      batchNoList: info.batchNoList && info.batchNoList.length > 0 ? info.batchNoList : null,
      batchStatusList: info.batchStatusList && info.batchStatusList.length > 0 ? info.batchStatusList : null,
      plantList: info.plantList && info.plantList.length > 0 ? info.plantList : null,
      disableDateStart: formatSpcStartTime(info.disableDate),
      disableDateEnd: formatSpcEndTime(info.disableDate),
      scanDateStart: formatSpcStartTime(info.scanDate),
      scanDateEnd: formatSpcEndTime(info.scanDate),
      disablementSubmitDateStart: formatSpcStartTime(info.disablementSubmitDate),
      disablementSubmitDateEnd: formatSpcEndTime(info.disablementSubmitDate),
      batchIds: selectedRowKeys,
      isChinese: languageState === 'zh_CN' ? true : false
    }
    delete params.disableDate
    delete params.scanDate
    delete params.disablementSubmitDate
    downloadBatchInfo(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const rowSelection = {
    selectedRowKeys,
    // getCheckboxProps: record => ({
    //   disabled: record.sendAntStatus !== 'FAILED'
    // }),
    onChange: onSelectChange
  }

  const requestChangeStatus = status => {
    const params = {
      batchIds: selectedRowKeys,
      batchStatus: status
    }
    changeWriteOffNFCBatchNumberStatus(params).then(res => {
      if (res.errorCode === '200') {
        message.success(formatMessageNew('languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      }
    })
  }

  const requestDisableStatus = () => {
    const params = {
      batchIds: selectedRowKeys
    }
    disableWriteOffNFCBatchNumberStatus(params).then(res => {
      if (res.errorCode === '200') {
        message.success(formatMessageNew('languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      }
    })
  }

  // 判断是否全部为 Disable
  const allDisable =
    selectedRowKeys.length > 0 &&
    selectedRowKeys.every(key => {
      const row = tableList.find(item => item.id === key)
      return row && (row.batchStatus === 'Submitted' || row.batchStatus === 'Fail')
    })

  // 判断是否全部为 Scanning
  const allScanning =
    selectedRowKeys.length > 0 &&
    selectedRowKeys.every(key => {
      const row = tableList.find(item => item.id === key)
      return row && row.batchStatus === 'Scanning'
    })

  // 判断是否全部为 Scan Complete
  const allScanComplete =
    selectedRowKeys.length > 0 &&
    selectedRowKeys.every(key => {
      const row = tableList.find(item => item.id === key)
      return row && row.batchStatus === 'Scan Complete'
    })

  const getPopoverContent = () => {
    return (
      <div>
        <div>
          <span style={{ fontWeight: 400 }}>{formatMessageNew('languageObj.writeOff.popOverMsgFon')}</span>
          <br />
          <span style={{ fontWeight: 400 }}>{formatMessageNew('languageObj.writeOff.popOverMsgBac')}</span>
        </div>
      </div>
    )
  }

  const uploadFun = file => {
    // file.append('account', account)
    uploadWriteOffNFCBatchNo(file)
      .then(res => {
        if (res.errorCode === '200') {
          // const data = res.resultData
          // modalSuccess({
          //   content: contentHtml(data)
          // })
          setQueryFlag(!queryFlag)
        }
      })
      .catch(error => {
        let msg = ''
        if (error.errorCode === '801') {
          msg = formatMessageNew('languageObj.configuration.errorcode_801')
        }
        if (error.errorCode === '2212') {
          msg = formatMessageNew('languageObj.writeOff.error_code_2212')
        }
        if (error.errorCode === '2213') {
          let index = 1
          msg = (
            <div>
              {error.resultData.noUidDataBatchNoList != null && error.resultData.noUidDataBatchNoList.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  {index++}. {formatMessageNew('languageObj.writeOff.tBatchNumber')} [
                  <span style={{ color: '#fa541c', fontWeight: 500 }}>
                    {error.resultData.noUidDataBatchNoList.join(', ')}
                  </span>
                  ]{formatMessageNew('languageObj.writeOff.noUidDataBatch')}
                </div>
              )}
              {error.resultData.notExitBatchNoList != null && error.resultData.notExitBatchNoList.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  {index++}. {formatMessageNew('languageObj.writeOff.tBatchNumber')} [
                  <span style={{ color: '#fa541c', fontWeight: 500 }}>
                    {error.resultData.notExitBatchNoList.join(', ')}
                  </span>
                  ]{formatMessageNew('languageObj.writeOff.batchNumberDnotExist')}
                </div>
              )}
              {error.resultData.notExitsUidList != null && error.resultData.notExitsUidList.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  {index++}. {formatMessageNew('languageObj.writeOff.tUid')} [
                  <span style={{ color: '#fa541c', fontWeight: 500 }}>
                    {error.resultData.notExitsUidList.join(', ')}
                  </span>
                  ]{formatMessageNew('languageObj.writeOff.noExitBatch')}
                </div>
              )}
              {error.resultData.alreadyDisabledBatchNoList != null &&
                error.resultData.alreadyDisabledBatchNoList.length > 0 && (
                  <div style={{ marginBottom: 8 }}>
                    {index++}. {formatMessageNew('languageObj.writeOff.tBatchNumber')} [
                    <span style={{ color: '#fa541c', fontWeight: 500 }}>
                      {error.resultData.alreadyDisabledBatchNoList.join(', ')}
                    </span>
                    ]{formatMessageNew('languageObj.writeOff.batchNumberAlreadyCf')}
                  </div>
                )}
              {error.resultData.notInCurrentBatchUidList != null &&
                error.resultData.notInCurrentBatchUidList.length > 0 && (
                  <div style={{ marginBottom: 8 }}>
                    {index++}. {formatMessageNew('languageObj.writeOff.tUid')} [
                    <span style={{ color: '#fa541c', fontWeight: 500 }}>
                      {error.resultData.notInCurrentBatchUidList.join(', ')}
                    </span>
                    ]{formatMessageNew('languageObj.writeOff.notInCurrentBatch')}
                  </div>
                )}
              {error.resultData.notScanCompleteBatchNoList != null &&
                error.resultData.notScanCompleteBatchNoList.length > 0 && (
                  <div style={{ marginBottom: 8 }}>
                    {index++}. {formatMessageNew('languageObj.writeOff.noScanBatch')} [
                    <span style={{ color: '#fa541c', fontWeight: 500 }}>
                      {error.resultData.notScanCompleteBatchNoList.join(', ')}
                    </span>
                    ]{formatMessageNew('languageObj.writeOff.batchNumberNoScan')}
                  </div>
                )}
            </div>
          )
        }
        if (error.errorCode === '2214') {
          msg = formatMessageNew('languageObj.writeOff.error_code_2214')
        }
        if (error.errorCode === '2215') {
          msg = (
            <div>
              {error.resultData.noAuthBatchNoList != null && error.resultData.noAuthBatchNoList.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  {formatMessageNew('languageObj.writeOff.tBatchNumber')} [
                  <span style={{ color: '#fa541c', fontWeight: 500 }}>
                    {error.resultData.noAuthBatchNoList.join(', ')}
                  </span>
                  ]{formatMessageNew('languageObj.writeOff.noBelongData')}
                </div>
              )}
            </div>
          )
        }
        modalError({
          content: msg,
          width: 800 // 或你需要的宽度
        })
      })
  }

  return (
    <Card bordered={false} bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchList}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>
      <div className="content-container">
        <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button
              onClick={() => requestDisableStatus()}
              disabled={
                !hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_disable) || !allDisable
              }
              danger={true}
              type="primary"
            >
              {formatMessageNew('languageObj.commonLocale.disableNfc')}
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: '20px' }}
              disabled={
                !hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_scanComplete) ||
                !allScanning
              }
              onClick={() => requestChangeStatus('Scan Complete')}
            >
              {formatMessageNew('languageObj.commonLocale.scanComplete')}
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: '20px' }}
              disabled={
                !hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_backToScanning) ||
                !allScanComplete
              }
              onClick={() => requestChangeStatus('Scanning')}
            >
              {formatMessageNew('languageObj.commonLocale.backToScanning')}
            </Button>
            <div style={{ marginLeft: '20px' }}>
              <span
                style={{
                  fontSize: 18,
                  color: '#1677ff',
                  fontWeight: 500,
                  textDecoration: 'underline',
                  cursor: hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload_submit)
                    ? 'pointer'
                    : 'not-allowed'
                }}
                onClick={() => {
                  if (hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload_submit)) {
                    uploadBtnRef.current && uploadBtnRef.current.triggerUpload()
                  }
                }}
              >
                {formatMessage(commonStore, 'languageObj.writeOff.uploadBtnMsg')}
              </span>
              <CustomUploadBtn
                uploadAjax={file => uploadFun(file)}
                ref={uploadBtnRef}
                {...props}
                disabled={!hasPermission(menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload_submit)}
              />
              <Popover
                trigger="click"
                color="#f5f5f5"
                className="mr10 cursorPointer"
                overlayStyle={{ maxWidth: '75vw', maxHeight: '95vh', overflow: 'auto' }}
                placement="right"
                content={getPopoverContent()}
              >
                <InfoCircleOutlined style={{ marginLeft: '6px', fontSize: 16, color: '#1677ff' }} />
              </Popover>
            </div>
            <Checkbox
              checked={autoRefresh}
              onChange={e => setAutoRefresh(e.target.checked)}
              style={{
                // marginLeft: languageState === 'zh_CN' ? '880px' : '570px',
                marginLeft: '10px',
                alignSelf: 'center'
              }}
            ></Checkbox>
          </div>
        </ActionBar>
        <div>
          <AntdTable
            // rowSelection={hasPermission(menu_nfc_report_fullTagReport) ? rowSelection : null}
            rowKey="id"
            rowSelection={rowSelection}
            dataSource={tableList || []}
            columns={tableColumns || []}
            // 独一无二的标识，不能重复
            columnsKey="columns_disableUidReport"
            iconTop={20}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </div>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        centered={true}
        className="nike_modal"
        width="100%"
        footer={null}
        title={<span style={{ fontWeight: 700 }}>{formatMessage(commonStore, 'languageObj.writeOff.detail')}</span>}
        onCancel={handleDetailCancel}
      >
        <div className="mt15">
          <div className="mb15">
            <span style={{ marginRight: '5px', fontWeight: 500 }}>
              {formatMessage(commonStore, 'languageObj.writeOff.batchNumber') + ': '}
            </span>
            <span style={{ marginRight: '20px', fontWeight: 400 }}>{batchNo}</span>
            <span style={{ marginRight: '5px', fontWeight: 500 }}>
              {formatMessage(commonStore, 'languageObj.writeOff.writeOffStatus') + ': '}
            </span>
            <span style={{ marginRight: '20px', fontWeight: 400 }}>{batchStatus}</span>
            <span style={{ marginRight: '5px', fontWeight: 500 }}>
              {formatMessage(commonStore, 'languageObj.writeOff.plant') + ': '}
            </span>
            <span style={{ marginRight: '20px', fontWeight: 400 }}>{plant}</span>
            <span style={{ marginRight: '5px', fontWeight: 500 }}>
              {formatMessage(commonStore, 'languageObj.writeOff.scannedQty') + ': '}
            </span>
            <span style={{ marginRight: '20px', fontWeight: 400 }}>{scanQty}</span>
          </div>
          <AntdTable
            dataSource={detailTableList || []}
            columns={disabaleUidDetailColumns || []}
            columnsKey="uidCollectionRecordColumns"
            pagination={detailPagination}
            onChange={handleDetailTableChange}
          />
        </div>
      </Modal>
    </Card>
  )
}
export default UIDDisablementReport
